import React from 'react';
import { Outlet } from 'react-router';
import { Link, useLocation } from 'react-router-dom';

import styles from '../styles/TopHeaderLayout.module.css';

export default function TopHeaderLayout() {
    const location = useLocation();

    return (
        <div className='mainContainer'>
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <Link className={styles.navBtnnn} to='/'><img style={{height: '25px', display: 'flex'}} src='/img/logo/mainlogo-1080.png' alt='ЛК СОАУ Альянс' /></Link>
                    <div>
                        <Link to='/legal/terms-of-use' className={styles.navBtnnn}>Условия использования</Link>
                        <Link to='/legal/privacy-policy' className={styles.navBtnnn}>Политика конфиденциальности</Link>
                        <Link to='/help' className={styles.navBtnnn}>Справка</Link>
                    </div>
                </div>
            </div>
            
            <Outlet />
        </div>
    )
}
